<template>
  <div class="flex items-stretch justify-center bg-gray-50">
    <div class="grid flex-1 p-16 place-items-center">
      <inline-svg src="maps/maps.svg" class="w-full h-auto max-w-screen-xl" />
    </div>
    <div class="w-2/5 px-12 py-20 space-y-4 xl:space-y-8 text-white bg-cover flex-shrink- 2xl:w-1/4" style="background-image: url('images/josefin-WS5yjFjycNY-unsplash-lightgreen.jpg')">
      <h1 class="mb-8 xl:mb-32 text-3xl font-bold uppercase">
        Location
      </h1>

      <div>
        <h2 class="mb-1 text-lg font-bold">
          แหล่งช้อปปิ้ง
        </h2>
        <div class="flex justify-between w-full">
          <span>เซ็นทรัล พลาซา ระยอง</span> <span>0.5 กม.</span>
        </div>
        <div class="flex justify-between w-full">
          <span>แม็คโคร ระยอง</span> <span>1.5 กม.</span>
        </div>
        <div class="flex justify-between w-full">
          <span>บิ๊กซีระยอง</span> <span>1.6 กม.</span>
        </div>
      </div>
      <div>
        <h2 class="mb-1 text-lg font-bold">
          สถานศึกษา
        </h2>
        <div class="flex justify-between w-full">
          <span>ร.ร.ระยองวิทยาคม</span> <span>4.5 กม.</span>
        </div>
        <div class="flex justify-between w-full">
          <span>ร.ร.อัสสัมชัญระยอง</span> <span>5.3 กม.</span>
        </div>
        <div class="flex justify-between w-full">
          <span>ร.ร.เซนต์โยเซฟระยอง</span> <span>5.5 กม.</span>
        </div>
      </div>
      <div>
        <h2 class="mb-1 text-lg font-bold">
          โรงพยาบาลและคลินิก
        </h2>
        <div class="flex justify-between w-full">
          <span>โรงพยาบาลระยอง</span> <span>1.7 กม.</span>
        </div>
        <div class="flex justify-between w-full">
          <span>โรงพยาบาลกรุงเทพระยอง</span> <span>5.6 กม.</span>
        </div>
      </div>
      <div>
        <h2 class="mb-1 text-lg font-bold">
          อื่นๆ
        </h2>
        <div class="flex justify-between w-full">
          <span>สถานีขนส่ง จังหวัดระยอง</span> <span>7.8 กม.</span>
        </div>
        <div class="flex justify-between w-full">
          <span>สนามบินนานาชาติอู่ตะเภา</span> <span>38 กม.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Location',
}
</script>
